import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { PaymentService } from 'src/app/services/payment.service';
import { RentingService } from 'src/app/services/renting.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { analytics } from '../dashboard.data';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html'
})
export class AnalyticsComponent implements OnInit {
  public analytics: any[] = [];
  public showXAxis = true;
  public showYAxis = true;
  public gradient = false;
  public showLegend = false;
  public showXAxisLabel = false;
  public xAxisLabel = 'Year';
  public showYAxisLabel = false;
  public yAxisLabel = 'Profit';
  public colorScheme:any = {
    domain: ['#283593', '#039BE5', '#FF5252']
  }; 
  public locations :any[]=[];
  public payment :any[]=[];
  public users :any[]=[];
  public cars :any[]=[];
  public autoScale = true;
  public roundDomains = true;
  @ViewChild('resizedDiv') resizedDiv!:ElementRef;
  public previousWidthOfResizedDiv:number = 0; 

  constructor(
    private locationService:RentingService,
    private paiementService:PaymentService,
    private userService:UserServiceService,
    private carService:VehiculeserviceService
  ) { }

  ngOnInit() {
    //this.analytics=analytics;
    this.loadData();
  }

  onSelect(event:any) {
    console.log(event);
  }

  public loadData()
  {
    let value:any[]=[];
    this.locationService.indexOn10Years().subscribe((res:any)=>{
      value.push({name:'Locations',series:res.rentings})
       this.paiementService.index10OnYears().subscribe((res:any)=>{
        value.push({name:'Paiements',series:res.paiements})
            this.userService.getUserOn10Ans().subscribe((res:any)=>{
              value.push({name:'Utilisateurs',series:res})
                this.carService.getallNbvehicleOn10Years().subscribe((res:any)=>{
                  value.push({name:'Vehicules',series:res})
                    this.analytics=value;
                 console.log(this.analytics);
            })
        })
      })
    })

   

   

    
  }

  ngAfterViewChecked() {    
    if(this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth){
      //this.loadData();
    
    }
    this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
  }

}